import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAddImage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAddImage"><Path d="M13 20.5H3.5V3.5L20.5 3.5V13" stroke="currentColor"/><Path d="M14.5 11.5C15.6046 11.5 16.5 10.6046 16.5 9.5C16.5 8.39543 15.6046 7.5 14.5 7.5C13.3954 7.5 12.5 8.39543 12.5 9.5C12.5 10.6046 13.3954 11.5 14.5 11.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 16.5L8 12L13 17" stroke="currentColor"/><Path d="M15 18.5H22" stroke="currentColor"/><Path d="M18.5 15V22" stroke="currentColor"/></CentralIconBase>;
});

export default IconAddImage;
